import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { AvatarModule } from "ngx-avatar";
import { NgxPermissionsModule } from "ngx-permissions";
import { SwiperModule } from "swiper/angular";
import { HeaderComponent } from "./components/header/header.component";
import { LeftSideMenuComponent } from "./components/left-side-menu/left-side-menu.component";
import { ModalComponent } from "./components/modal/modal.component";
import { SelectComponent } from "./components/select/select.component";
import { MaterialmodulesModule } from "./materialmodules.module";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { MatSliderModule } from "@angular/material/slider";
import { RouterModule } from "@angular/router";
import { NgbModule, NgbPaginationModule } from "@ng-bootstrap/ng-bootstrap";
import { ChartModule } from "angular-highcharts";
import { HighchartsChartModule } from "highcharts-angular";
import { NgCircleProgressModule } from "ng-circle-progress";
import { PdfViewerModule } from "ng2-pdf-viewer";
import { Ng2SearchPipeModule } from "ng2-search-filter";
import { QuillModule } from "ngx-quill";
import { TimeagoModule } from "ngx-timeago";
import { PowerBIEmbedModule } from "powerbi-client-angular";
import { BreadCrumbComponent } from "./components/bread-crumb/bread-crumb.component";
import { CommentsComponent } from "./components/comments/comments.component";
import { ConfirmModalComponent } from "./components/confirm-modal/confirm-modal.component";
import { DeletePopupComponent } from "./components/delete-popup/delete-popup.component";
import { FooterComponent } from "./components/footer/footer.component";
import { GnewsComponent } from "./components/gnews/gnews.component";
import { LabelInputComponent } from "./components/label-input/label-input.component";
import { LoadingComponent } from "./components/loading/loading.component";
import { ModalHeaderCommonComponent } from "./components/modal-header-common/modal-header-common.component";
import { OkrListingComponent } from "./components/okr-insight/okr-listing/okr-listing.component";
import { OwnerComponent } from "./components/owner/owner.component";
import { RightPanelStatementDetailsComponent } from "./components/right-panel-statement-details/right-panel-statement-details.component";
import { RisklogHeatmapComponent } from "./components/risklog-heatmap/risklog-heatmap.component";
import { SharedScopeComponent } from "./components/scope/scope.component";
import { IndividualScorecardComponent } from "./components/scorecard-matrix/individual-scorecard/individual-scorecard.component";
import { ScorecardComponent } from "./components/scorecard-matrix/scorecard/scorecard.component";
import { SelectionTreeListingComponent } from "./components/selection-tree-listing/selection-tree-listing.component";
import { SideMenuComponent } from "./components/side-menu/side-menu.component";
import { StatementResponseDetailsComponent } from "./components/statement-response-details/statement-response-details.component";
import { ConfirmationDialogComponent } from "./components/tag/confirmation-dialog/confirmation-dialog.component";
import { MessageDialogComponent } from "./components/modal/message-dialog/message-dialog.component";
import { TagComponent } from "./components/tag/tag.component";
import { TagMappedProjectsComponent } from "./components/tags-mapped-projects/tags-mapped-projects.component";
import { TreeListingComponent } from "./components/tree-listing/tree-listing.component";
import { WorkgroupComponent } from "./components/workgroup/workgroup.component";
import { PipeModule } from "./pipes/pipe.module";
import { TreefilterPipe } from "./pipes/treefilter.pipe";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { PowerBiModuleComponent } from "./power-bi-module/power-bi-module.component";
import { PulseComponent } from "./components/pulse/pulse.component";
import { OkrDialogComponent } from "./components/okr-dialog/okr-dialog.component";
import { FilterComponent } from "./filters/filter/filter.component";
import { SearchableMultiselectComponent } from "./filters/searchable-select/searchable-multiselect/searchable-multiselect.component";
import { SearchableSelectComponent } from "./filters/searchable-select/searchable-select/searchable-select.component";
import { DatepickerComponent } from "./filters/datepicker/datepicker/datepicker.component";
import { InputComponent } from "./filters/input/input/input.component";
import { NumberFormatDirective } from "./directives/number-format.directive";
import { MarkdownModule } from "ngx-markdown";
import { WidgetMetricDialogComponent } from "./components/scorecard-matrix/widget-metric-dialog/widget-metric-dialog.component";
import { MatRadioModule } from "@angular/material/radio";
import { RisklogDialogComponent } from "./components/risklog-heatmap/risklog-dialog/risklog-dialog.component";
import { ZohoDashboardComponent } from "./zoho-dashboard/zoho-dashboard.component";
import { MetricsIconComponent } from "./components/metrics-icon/metrics-icon.component";
import { HubbleInsightsComponent } from "./components/hubble-insights/hubble-insights.component";
import { ScorecardModalComponent } from "./components/scorecard-modal/scorecard-modal.component";
import { FinanceComparitorDialogComponent } from "./components/finance-comparitor-dialog/finance-comparitor-dialog.component";
import { FinanceComparitorComponent } from "./components/finance-comparitor/finance-comparitor.component";
import { AssessmentLibraryComponent } from "./components/assessment-library/assessment-library.component";
import { BvtCardComponent } from "./components/bvt-card/bvt-card.component";
import { AuditsLibraryComponent } from "./componets/audits-library/audits-library.component";
import { FinanceCalendarViewComponent } from "./components/finance-calendar-view/finance-calendar-view.component";
import { BudgetStatusIconComponent } from "./components/budget-status-icon/budget-status-icon.component";
import { OkrProgressComponent } from "./components/okr-progress/okr-progress.component";
import { AppFormatPipe, CurrencySymbolPipe } from "./pipes/app-format.pipe";
import { MAT_DATE_LOCALE, MAT_DATE_FORMATS } from "@angular/material/core";
import { CreateIdeaPitchComponent } from "./components/create-idea-pitch/create-idea-pitch.component";
import { MatIconModule } from "@angular/material/icon";
import { BudgetMapComponent } from "./components/scorecard-matrix/budget-map/budget-map.component";
import { MatTableModule } from "@angular/material/table";
import { TechMapDialogDataComponent } from "./components/tech-map-dialog-data/tech-map-dialog-data.component";
import { AccessDeniedComponent } from "./components/access-denied/access-denied.component";
import { HasAccessDirective } from "./directives/has-access.directive";
import { HasLicenseDirective } from "./directives/license-check.directive";
import { NoLicenseComponent } from "./components/no-license/no-license.component";
import { LinkedPiComponent } from "./components/linked-pi/linked-pi.component";
import { ActionHistoryComponent } from "./components/action-history/action-history.component";
import { AiroQueryConfirmDialogComponent } from "../pages/incident-tracker/compliance/controls/airo-query-confirm-dialog/airo-query-confirm-dialog.component";
import { KeywordsDialogComponent } from "./components/modal/keywords-dialog/keywords-dialog.component";
import { SignalsComponent } from "./components/signals/signals.component";
import { AiroChatComponent } from "./components/airo-chat/airo-chat.component";
import { ShareReviewComponent } from "./components/share-review/share-review.component";
import { AiroDataDialogComponent } from "./components/airo-data-dialog/airo-data-dialog.component";
import { MatPaginatorModule } from "@angular/material/paginator";
import { TemplateCreateModalDialogComponent } from "./components/template-create-modal/template-create-modal";
import { QnaGraphComponent } from "./components/qna-graph/qna-graph.component";
import { AuditTemplateEditDialogComponent } from "./components/audit-template-edit-dialog/audit-template-edit-dialog.component";
import { LlmInferenceComponent } from "./components/llm-inference/llm-inference.component";
import { StatusUpdatePopupComponent } from "./components/status-update-popup/status-update-popup.component";
import { AssessmentTemplateEditDialogComponent } from "./components/assessment-template-edit-dialog/assessment-template-edit-dialog.component";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { SearchableDropdownComponent } from './components/searchable-dropdown/searchable-dropdown.component';
import { RiskCreateDialogComponent } from "../pages/risk-convergence/risk-create-dialog/risk-create-dialog.component";
import { ActionCreateModalDialogComponent } from "./components/action-create-modal/action-create-modal";
import { ChangePasswordDialogComponent } from "./components/change-password-dialog/change-password-dialog.component";
// Read locale from appFormat in localStorage if present, otherwise default to en-GB which uses dd-MM-yyyy style

const APP_LOCALE = (() => {
  try {
    const cfg = JSON.parse(localStorage.getItem("appFormat") ?? "{}");
    return cfg.locale || "en-GB";
  } catch {
    return "en-GB";
  }
})();

export const APP_MAT_DATE_FORMATS = {
  parse: {
    dateInput: "MMM d, yyyy",
  },
  display: {
    dateInput: "MMM d, yyyy",
    monthYearLabel: "MMM yyyy",
    dateA11yLabel: "MMM d, yyyy",
    monthYearA11yLabel: "MMMM yyyy",
  },
};

@NgModule({
  declarations: [
    CreateIdeaPitchComponent,
    HeaderComponent,
    FooterComponent,
    ModalComponent,
    SelectComponent,
    LeftSideMenuComponent,
    SideMenuComponent,
    TreeListingComponent,
    SelectionTreeListingComponent,
    GnewsComponent,
    TreefilterPipe,
    DeletePopupComponent,
    StatusUpdatePopupComponent,
    BreadCrumbComponent,
    TagComponent,
    ConfirmationDialogComponent,
    MessageDialogComponent,
    LoadingComponent,
    ConfirmModalComponent,
    LabelInputComponent,
    OwnerComponent,
    WorkgroupComponent,
    CommentsComponent,
    ScorecardComponent,
    IndividualScorecardComponent,
    RightPanelStatementDetailsComponent,
    StatementResponseDetailsComponent,
    RisklogHeatmapComponent,
    RisklogDialogComponent,
    ModalHeaderCommonComponent,
    TagMappedProjectsComponent,
    SharedScopeComponent,
    OkrListingComponent,
    PowerBiModuleComponent,
    PulseComponent,
    OkrDialogComponent,
    FilterComponent,
    SearchableMultiselectComponent,
    SearchableSelectComponent,
    DatepickerComponent,
    InputComponent,
    WidgetMetricDialogComponent,
    MetricsIconComponent,
    ZohoDashboardComponent,
    HubbleInsightsComponent,
    ScorecardModalComponent,
    FinanceComparitorDialogComponent,
    FinanceComparitorComponent,
    AssessmentLibraryComponent,
    BvtCardComponent,
    AuditsLibraryComponent,
    FinanceCalendarViewComponent,
    BudgetStatusIconComponent,
    OkrProgressComponent,
    AppFormatPipe,
    CurrencySymbolPipe,
    NumberFormatDirective,
    BudgetMapComponent,
    TechMapDialogDataComponent,
    AccessDeniedComponent,
    HasAccessDirective,
    HasLicenseDirective,
    NoLicenseComponent,
    LinkedPiComponent,
    ActionHistoryComponent,
    AiroQueryConfirmDialogComponent,
    KeywordsDialogComponent,
    SignalsComponent,
    AiroChatComponent,
    ShareReviewComponent,
    AiroDataDialogComponent,
    TemplateCreateModalDialogComponent,
    QnaGraphComponent,
    AuditTemplateEditDialogComponent,
    LlmInferenceComponent,
    AssessmentTemplateEditDialogComponent,
    SearchableDropdownComponent,
    RiskCreateDialogComponent,
    ActionCreateModalDialogComponent,
    ChangePasswordDialogComponent
  ],

  imports: [
    CommonModule,
    MatIconModule,
    RouterModule,
    NgxDatatableModule,
    FormsModule,
    NgxPermissionsModule,
    AvatarModule,
    MatRadioModule,
    MatTableModule,
    SwiperModule,
    MaterialmodulesModule,
    NgbModule,
    NgCircleProgressModule.forRoot({}),
    Ng2SearchPipeModule,
    PipeModule,
    NgbPaginationModule,
    QuillModule,
    ChartModule,
    HighchartsChartModule,
    DragDropModule,
    PowerBIEmbedModule,
    MatSliderModule,
    MarkdownModule.forRoot(),
    MatCheckboxModule,
    MatPaginatorModule,
    PdfViewerModule,
    MatAutocompleteModule,
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    SelectComponent,
    BvtCardComponent,
    LeftSideMenuComponent,
    SideMenuComponent,
    TreeListingComponent,
    SelectionTreeListingComponent,
    GnewsComponent,
    Ng2SearchPipeModule,
    AvatarModule,
    DeletePopupComponent,
    StatusUpdatePopupComponent,
    BreadCrumbComponent,
    PipeModule,
    NgbPaginationModule,
    TagComponent,
    LoadingComponent,
    LabelInputComponent,
    OwnerComponent,
    WorkgroupComponent,
    TimeagoModule,
    CommentsComponent,
    ScorecardComponent,
    IndividualScorecardComponent,
    RightPanelStatementDetailsComponent,
    StatementResponseDetailsComponent,
    RisklogHeatmapComponent,
    RisklogDialogComponent,
    ModalHeaderCommonComponent,
    TagMappedProjectsComponent,
    OkrListingComponent,
    SharedScopeComponent,
    PdfViewerModule,
    MatCheckboxModule,
    PowerBiModuleComponent,
    PulseComponent,
    FilterComponent,
    SearchableMultiselectComponent,
    SearchableSelectComponent,
    DatepickerComponent,
    InputComponent,
    WidgetMetricDialogComponent,
    ZohoDashboardComponent,
    MetricsIconComponent,
    FinanceComparitorDialogComponent,
    FinanceComparitorComponent,
    AssessmentLibraryComponent,
    AuditsLibraryComponent,
    FinanceComparitorComponent,
    FinanceCalendarViewComponent,
    BudgetStatusIconComponent,
    OkrProgressComponent,
    AppFormatPipe,
    CurrencySymbolPipe,
    NumberFormatDirective,
    CreateIdeaPitchComponent,
    HasAccessDirective,
    AccessDeniedComponent,
    HasLicenseDirective,
    NoLicenseComponent,
    LinkedPiComponent,
    ActionHistoryComponent,
    AiroQueryConfirmDialogComponent,
    SignalsComponent,
    AiroChatComponent,
    ShareReviewComponent,
    AiroDataDialogComponent,
    QnaGraphComponent,
    AuditTemplateEditDialogComponent,
    LlmInferenceComponent,
    AssessmentTemplateEditDialogComponent,
    SearchableDropdownComponent,
    RiskCreateDialogComponent,
    ActionCreateModalDialogComponent,
    ChangePasswordDialogComponent
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: APP_LOCALE },
    { provide: MAT_DATE_FORMATS, useValue: APP_MAT_DATE_FORMATS },
  ],
  entryComponents: [ConfirmationDialogComponent, MessageDialogComponent, RiskCreateDialogComponent],
})
export class SharedModule { }
